import { render } from "./CodeSnippet.vue?vue&type=template&id=54eb4b80&scoped=true"
import script from "./CodeSnippet.vue?vue&type=script&lang=js"
export * from "./CodeSnippet.vue?vue&type=script&lang=js"

import "./CodeSnippet.vue?vue&type=style&index=0&id=54eb4b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54eb4b80"]])

export default __exports__